import type { JSX } from 'react';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

type HeadingProps = {
	petitionTitle: string;
	petitionCount: number;
	petitionCountLocalized: string;
	supporterCount: number;
	supporterCountLocalized: string;
};

export function HeadingPanel({
	petitionTitle,
	petitionCount,
	petitionCountLocalized,
	supporterCount,
	supporterCountLocalized,
}: HeadingProps): JSX.Element {
	return (
		<Flex sx={{ flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
			<Heading size="h6" as="h4" color="neutral-grey600">
				<Translate value="corgi.movement.show.heading.title" />
			</Heading>
			<Heading size="h1" mt={8}>
				{petitionTitle}
			</Heading>
			<Flex mt={16} mb={16} sx={{ minWidth: 240, alignItems: 'center' }}>
				<Box sx={{ flex: 1 }}>
					<Box>
						<Heading size="h3" as="h2">
							{petitionCountLocalized}
						</Heading>
					</Box>
					<Box>
						<Text>
							<TranslatePlural value="corgi.movement.show.heading.total_petitions_count_label" count={petitionCount} />
						</Text>
					</Box>
				</Box>
				<Box sx={{ flex: 1 }}>
					<Box>
						<Heading size="h3" as="h3">
							{supporterCountLocalized}
						</Heading>
					</Box>
					<Box>
						<Text>
							<TranslatePlural
								value="corgi.movement.show.heading.total_supporters_count_label"
								count={supporterCount}
							/>
						</Text>
					</Box>
				</Box>
			</Flex>
		</Flex>
	);
}
